module.exports = __webpack_public_path__ + "static/FRONTAL-82459a42c44089560069fcb7a661de90.webp";